var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"checkbox",class:{ checked: _vm.checked }},[(_vm.checked)?_c('div',{staticClass:"inner-circle"}):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }